import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  SearchInput,
} from "react-admin";

import { CLIENT_SEARCH_SOURCE } from "@/constants/filters";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const CitiesList = () => (
  <List
    actions={<ListActions />}
    filters={[
      <SearchInput
        key="search"
        source={CLIENT_SEARCH_SOURCE}
        placeholder="Search City"
        alwaysOn
      />,
    ]}
    storeKey={false}
    pagination={false}
  >
    <DatagridConfigurable bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      <TextField source="name" sortable={false} />
      <TextField source="heartbeatName" sortable={false} />
    </DatagridConfigurable>
  </List>
);
